var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimsborder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#E6EDEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2697 22.2927L35.502 19.525C34.5249 18.5479 33.2009 18 31.8186 18H26.253C23.377 18 21.0447 20.3323 21.0447 23.2083V37.7917C21.0447 40.6677 23.377 43 26.253 43H34.5863C37.4624 43 39.7947 40.6677 39.7947 37.7917V25.976C39.7947 24.5948 39.2457 23.2698 38.2697 22.2927ZM28.4166 30.5V33.625H25.2916C25.2916 31.899 26.6905 30.5 28.4166 30.5ZM30.4999 38.8333H28.4166C26.6905 38.8333 25.2916 37.4344 25.2916 35.7083H30.4999V38.8333ZM32.5832 38.8333V35.7083H35.7082C35.7082 37.4344 34.3093 38.8333 32.5832 38.8333ZM30.4999 33.625V30.5H32.5832C34.3093 30.5 35.7082 31.899 35.7082 33.625H30.4999Z",
    fill: "#224C44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimsborder);
export default __webpack_public_path__ + "static/media/simsborder.3f53a0f22cef594f0c8c0633bfa7d350.svg";
export { ForwardRef as ReactComponent };